import { useParams } from 'react-router-dom';
import { Label, Paper } from '../design/Paper';
import { ro } from '../i18n/ro';
import { RoomProvider } from '../state/RoomConnection';
import { RoomTokenContext } from '../state/roomToken';
import { ProjectorScreen } from '../screens/ProjectorScreen';
import { RoomScreen } from '../screens/RoomScreen';

/**
 * A room is reachable only by its direct link or QR code. The projector uses the
 * same link with a /projector suffix: a read-only view of the same room that
 * confers no privileges and shows nothing a player at the table lacks.
 */
export function RoomRoute({ projector = false }: { projector?: boolean }) {
  const { roomToken } = useParams<{ roomToken: string }>();

  if (!roomToken) {
    return (
      <Paper className="flex min-h-full items-center justify-center">
        <Label className="text-sm text-ink-soft">{ro.roomNotFound}</Label>
      </Paper>
    );
  }

  return (
    <RoomTokenContext.Provider value={roomToken}>
      <RoomProvider roomToken={roomToken} isProjector={projector}>
        {projector ? <ProjectorScreen /> : <RoomScreen />}
      </RoomProvider>
    </RoomTokenContext.Provider>
  );
}
